<template>
  <LoadingState
    v-if="!method"
    :loading="true"
  />
  <v-layout
    v-else
    row
    wrap
    color="transparent"
  >
    <v-flex
      v-if="method"
      xs12
      ma-3
    >
      <translations-tabs
        class="pb-4"
      >
        <template #default="{language}">
          <translatable
            :language="language"
            v-model="method"
            field-name="name"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('name')"
                :label="$t('Name')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
          <translatable
            :language="language"
            v-model="method"
            field-name="description"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('description')"
                :label="$t('Description')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
        </template>
      </translations-tabs>
      <v-text-field
        v-model="method.application_id"
        :error-messages="method.displayErrors('application_id')"
        :label="$t('Application ID')"
        outline
      />
      <v-text-field
        v-model="method.business_id"
        :error-messages="method.displayErrors('business_id')"
        :label="$t('Business ID')"
        outline
      />
      <v-text-field
        v-model="method.store_id"
        :error-messages="method.displayErrors('store_id')"
        :label="$t('Store ID')"
        outline
      />
      <v-text-field
        v-model.number="method.order"
        :error-messages="method.displayErrors('order')"
        :label="$t('Order')"
        type="number"
        outline
      />
      <application-select v-model="method.application"/>
      <image-upload v-model="method.image"/>
    </v-flex>
  </v-layout>
</template>

<script>
import ApplicationSelect from '@/components/form/ApplicationSelect'
import ImageUpload from '@/components/ImageUpload'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'
import LoadingState from '@/components/LoadingState'

export default {
  name: 'PaymentProviderPoynt',
  components: { Translatable, TranslationsTabs, ImageUpload, ApplicationSelect, LoadingState },
  props: {
    method: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      language: null,
      schema: {
        'code': '',
        'name': '',
        'enabled': true,
        'application': null,
        'business_id': '',
        'application_id': '',
        'store_id': '',
        'description': '',
        'image': '',
        'order': null
      },
      sensitiveErrorFields: {
        application_id: 'application id',
        business_id: 'business id'
      }
    }
  },

  created () {
    this.$emit('setPaymentData', {
      schema: this.schema,
      sensitiveErrorFields: this.sensitiveErrorFields
    })
  }
}
</script>
